import {
  IAdminHoleResultsStore,
  IHoleResult
} from '../../../../../../../store/admin/holeResults/store';
import { TIFormatPrefix } from '../../../../../../../store/admin/roundFormats/store';
import { IMetaResult } from '../../../../../../../store/admin/roundResults/store';
import { IHoleResultsStore } from '../../../../../../../store/player/holeResults/store';
import { ScoreType } from '../../../../../../../store/admin/eventFormats/store';

import { groupBy } from '../../../../../../../contrib/utils';
import { sortBy } from '../../../../../../../contrib/sortBy';
import { getResultFieldName } from '../../../ResultsTable/Utils/getResultFieldName';
import { IGBNResults, IStateDispatchActions } from '../AssignResults.context';

export type ISetGBNResults = (
  holeResults: IAdminHoleResultsStore | IHoleResultsStore,
  roundId: number,
  scoreType: ScoreType,
  considerFlight: boolean,
  flightId: number
) => void;

export const setGBNResults: IStateDispatchActions<ISetGBNResults> = (state, dispatch) => async (
  holeResults,
  roundId,
  scoreType,
  considerFlight,
  flightId
) => {
  if (holeResults[roundId]) {
    const processedPrefix = `gbn${considerFlight ? 'Flight' : 'Round'}` as TIFormatPrefix;

    const { selectedRoundFormat } = state;

    const winnerFieldName = getResultFieldName(
      processedPrefix,
      scoreType,
      'Winner',
      selectedRoundFormat ? selectedRoundFormat.adjustedHandicap : undefined
    ) as keyof IMetaResult;

    const participatingFieldName = getResultFieldName(
      processedPrefix,
      scoreType,
      'Participating'
    ) as keyof IMetaResult;

    const filteredHoleResults = holeResults[roundId].filter(
      (result: IHoleResult) =>
        result[winnerFieldName] &&
        result[participatingFieldName] &&
        flightId &&
        result.flightId === flightId
    );

    const sortedHoleResults: IHoleResult[] = sortBy(filteredHoleResults, 'asc', 'hole');
    const groupedHoleResults: IGBNResults = groupBy(sortedHoleResults, 'hole');

    if (filteredHoleResults) {
      dispatch({
        type: 'setGBNResults',
        value: groupedHoleResults
      });
    }
  }
};
